import { AuthService } from '@/auth';
import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  mixins: [
    AuthRoutes,
  ],
  data() {
    return {
      inputs: {
        email: {
          properties: {
            label: 'Email address',
            'label-icon': 'far fa-envelope',
            name: 'email',
            required: true,
            type: 'email',
            'validation-rules': 'required|email',
          },
          value: '',
        },
      },
      requestInProgress: false,
    };
  },
  methods: {
    async passwordReset() {
      this.requestInProgress = true;

      try {
        const email = this.inputs.email.value;
        await AuthService.passwordReset(email, true);
        this.$router.push({
          ...this.routes.passwordResetRequested,
          params: {
            emailAddress: email,
          },
        });
      } catch (error) {
        // Do nothing
      }

      this.requestInProgress = false;
    },
  },
};
